import ENV_VARS from '../utils/envVars';

export const AUTH_BASIC_SUCCESS = 'AUTH_BASIC_SUCCESS';
export const AUTH_BASIC_FAILURE = 'AUTH_BASIC_FAILURE';
export const AUTH_REFRESH_SUCCESS = 'AUTH_REFRESH_SUCCESS';
export const AUTH_REFRESH_FAILURE = 'AUTH_REFRESH_FAILURE';
export const PASSWORD_CHANGE_SUCCESS = 'PASSWORD_CHANGE_SUCCESS';
export const PASSWORD_CHANGE_FAILURE = 'PASSWORD_CHANGE_FAILURE';

export function authUserBasic(email, password) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/login',
    method: 'POST',
    data: {
      username: email,
      password,
    },
  };
  return {
    type: 'API_CALL',
    config,
    auth: false,
    spinner: true,
    successAction: AUTH_BASIC_SUCCESS,
    failureAction: AUTH_BASIC_FAILURE,
  };
}

export function authUserRefresh(token) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/refresh',
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      version: '1000.0.0',
    },
  };
  return {
    type: 'API_CALL',
    config,
    auth: false,
    successAction: AUTH_REFRESH_SUCCESS,
    failureAction: AUTH_REFRESH_FAILURE,
  };
}

export function changeUserPassword(data) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/update-password',
    method: 'PUT',
    data,
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: PASSWORD_CHANGE_SUCCESS,
    failureAction: PASSWORD_CHANGE_FAILURE,
  };
}
